<template>
  <div class="account">
    <div class="accountmsg box">
      <p class="title">账号信息</p>
      <img :src="userdata.avatar" alt="" class="avatar" />
      <ul>
        <li>用户名称</li>
        <li>{{ userdata.nickname }}</li>
        <li></li>
      </ul>
      <ul>
        <li>用户ID</li>
        <li>{{ userdata.id }}</li>
        <li></li>
      </ul>
      <ul>
        <li>会员版本</li>
        <li>{{ userdata.vip_desc }}</li>
        <li class="blue">
          <p v-show="userdata.show_open_vip_btn" @click="dialogVisible = true">
            去开通<i class="el-icon-arrow-right"></i>
          </p>
        </li>
      </ul>
      <ul>
        <li>AI点数</li>
        <li>{{ userdata.ai_drop }}</li>
        <li class="blue" @click="jumppage('/point')">
          点数记录<i class="el-icon-arrow-right"></i>
        </li>
      </ul>
    </div>
    <div class="accountmanage box">
      <p class="title">账号管理</p>
      <ul>
        <li>微信</li>
        <li>{{ userdata.wechat }}</li>
        <li
          v-if="userdata.wechat == '未绑定'"
          class="blue"
          @click="wechatCode()"
        >
          去绑定<i class="el-icon-arrow-right"></i>
        </li>
        <li v-else @click="userUnbindWechat()">解绑<i class="el-icon-arrow-right"></i></li>
      </ul>
      <ul>
        <li>手机</li>
        <li>{{ userdata.mobile }}</li>
        <li
          v-if="userdata.mobile == '未绑定'"
          class="blue"
          @click="modalstatus = true"
        >
          去绑定<i class="el-icon-arrow-right"></i>
        </li>
        <li v-else @click="changestatus=true">更换手机号<i class="el-icon-arrow-right"></i></li>
      </ul>
    </div>

    <div class="modal-wrap" v-show="modalstatus">
      <div class="phonebox">
        <div class="phonemsg">
          <p>绑定手机号</p>
          <p>首次绑定可以获赠AI点数哦</p>
          <div class="phone">
            <el-input
              maxlength="11"
              placeholder="请输入手机号"
              v-model="form.mobile"
            >
              <span slot="prefix">+86</span>
            </el-input>
          </div>
          <div class="codebox">
            <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
            <el-button :disabled="disabled ? true : false" @click="smsSendV2(form.mobile)">{{
              text
            }}</el-button>
          </div>
          <el-button
            type="primary"
            class="submit"
            @click="userBindMobileForCenter(form)"
            style="width: 100%"
            >绑定</el-button
          >
        </div>
        <div class="close" @click="modalstatus = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>

    <div class="modal-wrap" v-show="changestatus">
      <div class="phonebox" v-if="phonestatus">
        <div class="phonemsg">
          <p style="margin-bottom:40px">验证手机号</p>
          <!-- <p>首次绑定可以获赠AI点数哦</p> -->
          <div class="phone">
            <el-input
              maxlength="11"
              placeholder="请输入手机号"
              disabled
              v-model="checkform.mobile"
            >
              <span slot="prefix">+86</span>
            </el-input>
          </div>
          <div class="codebox">
            <el-input v-model="checkform.code" placeholder="请输入验证码"></el-input>
            <el-button :disabled="disabled ? true : false" @click="smsSendV2(checkform.mobile)">{{text}}</el-button>
          </div>
          <el-button
            type="primary"
            class="submit"
            @click="userBindMobileForCenter(checkform)"
            style="width: 100%"
            >验证</el-button
          >
        </div>
        <div class="close" @click="changestatus = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="phonebox" v-else>
        <div class="phonemsg">
          <p style="margin-bottom:40px">更换手机号</p>
          <!-- <p>首次绑定可以获赠AI点数哦</p> -->
          <div class="phone">
            <el-input
              maxlength="11"
              placeholder="请输入手机号"
              v-model="changeform.mobile"
            >
              <span slot="prefix">+86</span>
            </el-input>
          </div>
          <div class="codebox">
            <el-input v-model="changeform.code" placeholder="请输入验证码"></el-input>
            <el-button :disabled="disabled ? true : false" @click="smsSendV2(changeform.mobile)">{{text}}</el-button>
          </div>
          <el-button
            type="primary"
            class="submit"
            @click="userBindMobileForCenter(changeform)"
            style="width: 100%"
            >更换</el-button
          >
        </div>
        <div class="close" @click="changestatus = false;phonestatus=true">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>

    <div class="modal-wrap" v-show="wechatstatus">
      <div class="phonebox">
        <div class="wechatmsg">
          <img :src="wechat.qrcode" alt="" />
        </div>
      </div>
    </div>

    <membertc v-if="dialogVisible" @closemember="closemember"></membertc>
  </div>
</template>

<script>
var _this;
import {
  getAccountSetting,
  userBindMobileForCenter,
  smsSendV2,
  userUnbindWechat,
} from "@/api/user";
import { wechatCode, userScanLogin } from "@/api/login";
import { validatePhoneNumber } from "@/utils/commom";
import membertc from "@/components/membertc";
export default {
  components: {
    membertc,
  },
  data() {
    return {
      phonestatus:true,
      changestatus:false,
      dialogVisible: false,
      wechat: "",
      text: "获取验证码",
      second: 60,
      disabled: false,
      modalstatus: false,
      wechatstatus: false,
      userdata: {},
      form: {
        mobile: "",
        code: "",
        type:"bind"
      },
      checkform:{
        mobile: "",
        code: "",
        type:"check",
      },
      changeform:{
        mobile: "",
        code: "",
        type:"change"
      },
      wechat: {},
      time: "",
    };
  },
  mounted() {
    _this = this;
    getAccountSetting().then((res) => {
      this.checkform.mobile = res.data.mobile
      this.userdata = res.data;
    });
  },
  methods: {
    userUnbindWechat() {
       this.$confirm("是否确定解绑微信", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        }).then(() => {
            userUnbindWechat().then(res=>{
                location.reload();
            })
        })
    },
    closemember() {
      this.dialogVisible = false;
    },
    wechatCode() {
      this.wechatstatus = true;
      wechatCode().then((res) => {
        _this.wechat = res.data;
        _this.userScanLogin();
      });
    },
    //扫码登录
    userScanLogin() {
      _this.time = setInterval(function(){
        userScanLogin({ ticket: _this.wechat.ticket }).then((res) => {
          if (res.code == 0) {
            clearInterval(_this.time);
            location.reload();
          }
        });
      }, 1000);
    },
    userBindMobileForCenter(data) {
      userBindMobileForCenter(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.message,
            type: "success",
          });
          if(data.type=="check"){
            this.phonestatus = false
          }else{
            location.reload();
          }
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
        _this.modalstatus = false;
      });
    },
    smsSendV2(mobile) {
      if (!validatePhoneNumber(mobile)) {
        _this.$message.error("手机号码格式错误");
        return false;
      }
      smsSendV2({ mobile:mobile }).then((res) => {
        _this.disabled = true;
        let time = setInterval(() => {
          _this.text = _this.second + "s";
          _this.second--;
          if (_this.second == 0) {
            _this.second = 60;
            _this.disabled = false;
            clearInterval(time);
          }
        }, 1000);
      });
    },
    jumppage(router) {
      console.log(router);
      this.$router.push({ path: router });
    },
  },
};
</script>

<style lang="less">
.account {
  height: calc(100% - 48px);
  margin: 24px 0 24px 24px;
  .box {
    width: 678px;
    background: #fdfeff;
    border-radius: 12px;
    box-sizing: border-box;
    padding: 24px 32px;
    margin-bottom: 20px;
    border-width: 1px;
    border-style: solid;
    border-color: #f4f5f7;
    .title {
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: #1d2129;
      margin-bottom: 16px;
    }
  }
  .accountmsg {
    .avatar {
      width: 40px;
      display: block;
      margin: 0 auto;
    }
    ul {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding-bottom: 24px;
      border-bottom: 1px solid #f4f4f4;
      width: 100%;
      margin-bottom: 24px;
      li:nth-child(1) {
        width: 80px;
        display: block;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: #4e5969;
        margin-right: 24px;
        text-align: left;
      }
      li:nth-child(2) {
        flex: 1 0 10%;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: #1d2129;
      }
      li:nth-child(3) {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: #999;
        cursor: pointer;
      }
      .blue {
        color: #2d8af5 !important;
      }
    }
    ul:last-child {
      padding-bottom: 0;
      border-bottom: transparent;
      margin-bottom: 0;
    }
  }

  .accountmanage {
    .title {
      margin-bottom: 32px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding-bottom: 24px;
      border-bottom: 1px solid #f4f4f4;
      width: 100%;
      margin-bottom: 24px;
      li:nth-child(1) {
        width: 80px;
        display: block;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: #4e5969;
        margin-right: 24px;
        text-align: left;
      }
      li:nth-child(2) {
        flex: 1 0 10%;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: #1d2129;
      }
      li:nth-child(3) {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        color: #999;
        cursor: pointer;
      }
      .blue {
        color: #2d8af5 !important;
      }
    }
    ul:last-child {
      padding-bottom: 0;
      border-bottom: transparent;
      margin-bottom: 0;
    }
  }
  .modal-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    .phonebox {
      .wechatmsg {
        width: 340px;
        height: 326px;
        background: #ffffff;
        border-radius: 12px;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .phonemsg {
        width: 340px;
        height: 326px;
        background: #ffffff;
        border-radius: 12px;
        padding: 44px 25px;
        p:nth-child(1) {
          font-style: normal;
          font-weight: 700;
          font-size: 20px;
          line-height: 26px;
          color: #1d2129;
          text-align: center;
        }
        p:nth-child(2) {
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          color: #999;
          margin-bottom: 27px;
          margin-top: 4px;
          text-align: center;
        }
        .phone {
          .el-input__inner {
            padding-left: 60px;
          }
          .el-input__prefix {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            color: rgb(144, 147, 153);
            font-size: 12px;
            letter-spacing: 1px;
            // position: relative;
          }
          .el-input__prefix::after {
            content: "";
            width: 0.5px;
            height: 16px;
            background-color: #e5e8ef;
            margin-left: 8px;
          }
        }

        .codebox {
          margin: 24px 0;
          display: flex;
          justify-content: space-between;
          .el-button {
            margin-left: 20px;
          }
        }
      }
    }
    .close {
      width: 28px;
      height: 28px;
      font-size: 16px;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px auto 0;
      cursor: pointer;
    }
  }
}
</style>